// extracted by mini-css-extract-plugin
export default {"dotFlashing":"LaSpinner_dotFlashing__JOraj","dotFlashingSmall":"LaSpinner_dotFlashingSmall__8KIj+"};